export function loadScript(
  src: string,
  { async = true, fetchPriority = 'auto' }: LoadScriptOptions = {}
) {
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');

    script.src = src;
    script.async = async;
    script.fetchPriority = fetchPriority;

    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      reject(new Error('Failed to load script'));
    };

    document.head.appendChild(script);
  });
}

export type LoadScriptOptions = {
  async?: boolean;
  fetchPriority?: 'high' | 'low' | 'auto';
};
